exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.style_hide-sm__3vFhG{display:none!important}}@media (min-width:37.4rem){.style_visible-sm__20C9B{display:none!important}}@media (max-width:79.9rem){.style_hide-md__1BZaV{display:none!important}}@media (min-width:79.9rem){.style_visible-md__1kb-w{display:none!important}}.style_formContainer__1XosJ{display:flex;flex-direction:column;align-items:stretch;flex:1 1 auto}", ""]);

// exports
exports.locals = {
	"hide-sm": "style_hide-sm__3vFhG",
	"hideSm": "style_hide-sm__3vFhG",
	"visible-sm": "style_visible-sm__20C9B",
	"visibleSm": "style_visible-sm__20C9B",
	"hide-md": "style_hide-md__1BZaV",
	"hideMd": "style_hide-md__1BZaV",
	"visible-md": "style_visible-md__1kb-w",
	"visibleMd": "style_visible-md__1kb-w",
	"formContainer": "style_formContainer__1XosJ"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/FormPaperLayout/style.less
// module id = 1739
// module chunks = 8